import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { CopilotPanel } from '../../components/cdp-ai/CopilotPanel';

/**
 * Layout wrapper for all /customers/* routes.
 * Mounts the CDP AI CopilotPanel as a persistent side panel
 * scoped only to the customers (CDP) section.
 */
const CustomersLayout: React.FC = () => {
  const location = useLocation();
  return (
    <div className="flex h-full">
      <main className="flex-1 min-w-0 overflow-y-auto">
        <Outlet />
      </main>
      <CopilotPanel pageContext={location.pathname} />
    </div>
  );
};

export default CustomersLayout;
